import { render, staticRenderFns } from "./tooltip-icon.vue?vue&type=template&id=2629fafc&scoped=true"
import script from "./tooltip-icon.vue?vue&type=script&lang=js"
export * from "./tooltip-icon.vue?vue&type=script&lang=js"
import style0 from "./tooltip-icon.vue?vue&type=style&index=0&id=2629fafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2629fafc",
  null
  
)

export default component.exports